export default "__VITE_ASSET__DfVVF6qs__"